<template>
    <div class="install-group" :class="{loading: loading}">
        <div class="open-wrapper pointer" @click="openModal">
            <slot>
                <a href="javascript://void(0)">Open</a>
            </slot>
        </div>

        <modal :name=modalId
               :adaptive="true"
               :scrollable="true"
               @before-close="beforeClose"
               height="auto">
            <div class="dashboard-block" :class="{loading: loading}">
                <header>
                    <h4 v-if="model.created_at" class="display-block">
                        {{model.name}}
                        <span v-if="model.archivedLabel" v-html="model.archivedLabel"></span>
                    </h4>
                    <h4 v-else>Create Install Group</h4>

                    <h5 v-if="model.created_at">Install Group</h5>

                    <a href="javascript://void(0)" class="back" @click="closeModal">Close</a>
                </header>

                <tabs>
                    <tab title="Edit">
                        <form @submit.prevent="saveModel" accept-charset="UTF-8" novalidate="novalidate"
                              data-vv-scope="installGroup">
                            <fieldset>
                                <legend>Install Group</legend>

                                <div class="form-group has-feedback"
                                     :class="{'has-error': errors.has('installGroup.InstallGroup[name]')}">
                                    <label for="install-group-name">Name</label>
                                    <input id="install-group-name"
                                           v-validate="'required'"
                                           v-model="model.name"
                                           name="InstallGroup[name]"
                                           type="text"
                                           class="form-control"
                                           aria-required="true">

                                    <span v-show="errors.has('installGroup.InstallGroup[name]')" class="help-block">
                                        {{ errors.first('installGroup.InstallGroup[name]') }}
                                    </span>
                                </div>

                                <hr v-if="!model.deleted_at">

                                <div class="row">
                                    <div class="col-xs-6">
                                        <button type="button" class="btn btn-sm btn-warning"
                                                @click="deleteModel"
                                                v-if="model.created_at && !model.deleted_at"
                                                :disabled="loading">
                                            <i class="fa fa-trash" aria-hidden="true"></i>
                                        </button>

                                        <button type="button" class="btn btn-sm btn-warning"
                                                @click="restoreModel"
                                                v-if="model.created_at && model.deleted_at"
                                                :disabled="loading">
                                            <i class="fa fa-refresh" aria-hidden="true"></i>
                                        </button>
                                    </div>

                                    <div class="col-xs-6 form-group pull-right" v-if="!model.deleted_at">
                                        <button type="submit" class="btn btn-success btn-block" :disabled="loading">
                                            Save
                                        </button>
                                    </div>
                                </div>
                            </fieldset>
                        </form>
                    </tab>

                    <tab title="Notifications" v-if="model.created_at">
                        <fieldset>
                            <legend>
                                <div class="row">
                                    <div class="col-sm-6 col-md-7 text-right form-group pull-sm-right">
                                        Notifications
                                    </div>

                                    <div class="col-sm-6 col-md-5 form-group align-sm-left">
                                        <button type="button" class="btn btn-sm"
                                                :class="{ 'btn-excellent': !showCreateNotification, 'btn-default': showCreateNotification }"
                                                @click="showCreateNotification = !showCreateNotification">

                                            <span v-if="!showCreateNotification">
                                                Schedule Notifications
                                            </span>
                                            <span v-else>
                                                Cancel
                                            </span>
                                        </button>
                                    </div>
                                </div>
                            </legend>

                            <form @submit.prevent="scheduleNotifications" accept-charset="UTF-8" novalidate="novalidate"
                                  data-vv-scope="notifications" v-if="showCreateNotification">

                                <div class="form-group has-feedback"
                                     :class="{'has-error': errors.has('notifications.Notification[scheduled_at]')}">
                                    <label for="notification-scheduled-at">Send At</label>

                                    <div class="row">
                                        <div class="col-xs-7">
                                            <input id="notification-scheduled-at-date"
                                                   type="date"
                                                   placeholder="YYYY-MM-DD"
                                                   class="form-control"
                                                   v-model="notification.scheduled_at_date">
                                        </div>
                                        <div class="col-xs-5">
                                            <input id="notification-scheduled-at-time"
                                                   type="time"
                                                   placeholder="HH:MM"
                                                   class="form-control"
                                                   v-model="notification.scheduled_at_time">
                                        </div>
                                    </div>

                                    <input type="hidden"
                                           id="notification-scheduled-at"
                                           name="Notification[scheduled_at]"
                                           v-validate="'required'"
                                           :value="notificationScheduledAt">

                                    <span v-show="errors.has('notifications.Notification[scheduled_at]')"
                                          class="help-block">
                                        {{ errors.first('notifications.Notification[scheduled_at]') }}
                                    </span>
                                </div>

                                <div class="form-group has-feedback"
                                     :class="{'has-error': errors.has('notifications.Notification[unit_entry_id]')}">

                                    <label for="notification-unit-entry-id">Unit Entry</label>
                                    <select id="notification-unit-entry-id"
                                            class="form-control"
                                            v-validate="'required'"
                                            v-model="notification.unit_entry_id"
                                            name="Notification[unit_entry_id]">
                                        <option value="">-</option>
                                        <option v-for="unitEntry in model.unitEntries" :value="unitEntry.id">
                                            {{unitEntry.title}}
                                        </option>
                                    </select>

                                    <span v-show="errors.has('Notification[unit_entry_id]')" class="help-block">
                                        {{ errors.first('Notification[unit_entry_id]') }}
                                    </span>
                                </div>

                                <hr>

                                <div class="row">
                                    <div class="col-xs-6 form-group pull-right">
                                        <button type="submit" class="btn btn-success btn-block" :disabled="loading">
                                            Schedule Notifications
                                        </button>
                                    </div>
                                </div>

                                <br>
                            </form>

                            <div class="list-group">
                                <a href="javascript://void(0)" class="list-group-item"
                                   :class="{'list-group-item-success active':showUnitEntryNotifications[listUnitEntry.id]}"
                                   v-for="listUnitEntry in model.unitEntries"
                                   :key="listUnitEntry.id"
                                   role="button">

                                    <div @click="toggleUnitEntryNotifications(listUnitEntry.id)" class="pointer">
                                        <h4 class="panel-title text-bold"
                                            :class="{'text-white' : showUnitEntryNotifications[listUnitEntry.id]}">
                                            {{listUnitEntry.title}}
                                        </h4>
                                        <h6>
                                            {{listUnitEntry.display_start_at}} - {{listUnitEntry.display_end_at}}
                                        </h6>
                                    </div>

                                    <br>

                                    <div class="form-group text-right"
                                         v-if="unitEntryMeta[listUnitEntry.id] && unitEntryMeta[listUnitEntry.id].hasUnsentNotifications">
                                        <a href="javascript://void(0)" class="btn btn-sm btn-warning"
                                           @click="deleteUnsentNotification(listUnitEntry)">
                                            Remove Unsent Notifications
                                        </a>
                                    </div>

                                    <div v-show="showUnitEntryNotifications[listUnitEntry.id]">
                                        <ul class="list-group">
                                            <li class="list-group-item"
                                                v-for="emailNotification in listUnitEntry.emailNotifications"
                                                :key="emailNotification.id"
                                                @click="notification = emailNotification">

                                                <h6 class="margin-sm-bottom">
                                                    <a :href="'mailto:' + emailNotification.to">{{emailNotification.to}}</a>
                                                </h6>

                                                <div class="row">
                                                    <div class="col-sm-7">
                                                        <span class="label label-success"
                                                              v-if="emailNotification.sent_at !== null">
                                                        Sent at {{emailNotification.sent_at}}
                                                        </span>
                                                        <span class="label label-primary"
                                                              v-else-if="emailNotification.scheduled_at !== null">
                                                        Scheduled for {{emailNotification.scheduled_at}}
                                                        </span>
                                                    </div>
                                                    <div class="col-sm-5 align-sm-right"
                                                         v-if="!emailNotification.sent_at && notification.id === emailNotification.id">
                                                        <button class="btn btn-sm btn-warning" type="button"
                                                                @click="deleteEmailNotification(emailNotification)">
                                                            <i class="fa fa-trash" aria-hidden="true"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </li>
                                            <li class="list-group-item"
                                                v-for="smsNotification in listUnitEntry.smsNotifications"
                                                :key="smsNotification.id"
                                                @click="notification = smsNotification">

                                                <h6 class="margin-sm-bottom">
                                                    <a :href="'tel:' + smsNotification.to">{{smsNotification.to}}</a>
                                                </h6>

                                                <div class="row">
                                                    <div class="col-sm-7">
                                                        <span class="label label-success"
                                                              v-if="smsNotification.sent_at !== null">
                                                        Sent at {{smsNotification.sent_at}}
                                                        </span>
                                                        <span class="label label-primary"
                                                              v-else-if="smsNotification.scheduled_at !== null">
                                                            Scheduled for {{smsNotification.scheduled_at}}
                                                        </span>
                                                    </div>
                                                    <div class="col-sm-5 align-sm-right"
                                                         v-if="!smsNotification.sent_at && notification.id === smsNotification.id">
                                                        <button class="btn btn-sm btn-warning" type="button"
                                                                @click="deleteSmsNotification(smsNotification)">
                                                            <i class="fa fa-trash" aria-hidden="true"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </a>
                            </div>
                        </fieldset>
                    </tab>

                    <tab title="Unit Blocks" v-if="model.created_at">
                        <fieldset>
                            <legend>
                                <div class="row">
                                    <div class="col-sm-6 col-md-7 text-right form-group pull-sm-right">
                                        Unit Blocks
                                    </div>

                                    <div class="col-sm-6 col-md-5 form-group align-sm-left">
                                        <button type="button" class="btn btn-sm"
                                                :class="{ 'btn-excellent': !showUnitBlock, 'btn-default': showUnitBlock }"
                                                @click="setUnitBlock(false); showUnitBlock = !showUnitBlock">
                                            <span v-if="!showUnitBlock">
                                                Create Unit Block
                                            </span>
                                            <span v-else>
                                                Cancel
                                            </span>
                                        </button>
                                    </div>
                                </div>
                            </legend>

                            <form @submit.prevent="saveUnitBlock" accept-charset="UTF-8" novalidate="novalidate"
                                  data-vv-scope="unitBlock" v-if="showUnitBlock">

                                <div class="row">
                                    <div class="form-group has-feedback col-sm-6"
                                         :class="{'has-error': errors.has('unitBlock.UnitBlock[start_unit]')}">
                                        <label for="unit-block-start-unit">Start Unit</label>
                                        <input id="unit-block-start-unit"
                                               v-validate="'required'"
                                               v-model="unitBlock.start_unit"
                                               name="UnitBlock[start_unit]"
                                               type="text"
                                               class="form-control"
                                               aria-required="true">

                                        <span v-show="errors.has('unitBlock.UnitBlock[start_unit]')" class="help-block">
                                            {{ errors.first('unitBlock.UnitBlock[start_unit]') }}
                                        </span>
                                    </div>

                                    <div class="form-group has-feedback col-sm-6"
                                         :class="{'has-error': errors.has('unitBlock.UnitBlock[end_unit]')}">
                                        <label for="unit-block-end-unit">End Unit</label>
                                        <input id="unit-block-end-unit"
                                               v-validate="'required'"
                                               v-model="unitBlock.end_unit"
                                               name="UnitBlock[end_unit]"
                                               type="text"
                                               class="form-control"
                                               aria-required="true">

                                        <span v-show="errors.has('unitBlock.UnitBlock[end_unit]')" class="help-block">
                                            {{ errors.first('unitBlock.UnitBlock[end_unit]') }}
                                        </span>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-sm-6 col-md-4 form-group has-feedback"
                                         :class="{'has-error': errors.has('unitBlock.UnitBlock[filter]')}">
                                        <label for="unit-block-filter">Filter</label>

                                        <select id="unit-block-filter"
                                                class="form-control"
                                                v-model.number="unitBlock.filter"
                                                name="UnitBlock[filter]">
                                            <option value="">None</option>
                                            <option value="0">Even</option>
                                            <option value="1">Odd</option>
                                            <option value="2">Like Match</option>
                                        </select>

                                        <span v-show="errors.has('unitBlock.UnitBlock[filter]')" class="help-block">
                                            {{ errors.first('unitBlock.UnitBlock[filter]') }}
                                        </span>
                                    </div>

                                    <div class="col-sm-6 col-md-8 form-group has-feedback"
                                         v-if="unitBlock.filter === 2"
                                         :class="{'has-error': errors.has('unitBlock.UnitBlock[filter_match]')}">
                                        <label for="unit-block-filter-match">Filter</label>

                                        <input id="unit-block-filter-match"
                                               v-validate="'required'"
                                               v-model="unitBlock.filter_match"
                                               name="UnitBlock[filter_match]"
                                               type="text"
                                               class="form-control"
                                               aria-required="true">

                                        <h6 class="margin-sm-top">Use the % symbol for wildcard matching</h6>

                                        <span v-show="errors.has('unitBlock.UnitBlock[filter_match]')"
                                              class="help-block">
                                            {{ errors.first('unitBlock.UnitBlock[filter_match]') }}
                                        </span>
                                    </div>
                                </div>

                                <hr>

                                <div class="row">
                                    <div class="col-xs-6 form-group">
                                        <button type="button" class="btn btn-sm btn-warning"
                                                @click="deleteUnitBlock( unitBlock )"
                                                :disabled="loading">
                                            <i class="fa fa-trash" aria-hidden="true"></i>
                                        </button>
                                    </div>

                                    <div class="col-xs-6 form-group pull-right">
                                        <button type="submit" class="btn btn-success btn-block" :disabled="loading">
                                            Save Unit Block
                                        </button>
                                    </div>
                                </div>

                                <br>
                            </form>

                            <ul class="list-group">
                                <li class="list-group-item link" v-for="listUnitBlock in model.unitBlocks"
                                    :class="{'list-group-item-success active': unitBlock.id === listUnitBlock.id}"
                                    @click="setUnitBlock(listUnitBlock); showUnitBlock = true">
                                    {{listUnitBlock.start_unit}} - {{listUnitBlock.end_unit}}
                                    <span v-html="listUnitBlock.filterLabel"></span>
                                </li>
                            </ul>

                            <div class="text-right" v-if="model.residents">
                                Count: {{model.residents.length}}
                            </div>

                            <table class="table table-striped table-hover table-condensed no-margin">
                                <thead>
                                <tr>
                                    <th>Unit</th>
                                    <th>Resident</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="resident in model.residents">
                                    <td>{{resident.unit}}</td>
                                    <td>
                                        <a :href="'/residents/' + resident.id">{{resident.fullName}}</a>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </fieldset>
                    </tab>

                    <tab title="Unit Entries" v-if="model.created_at">
                        <fieldset>
                            <legend>
                                <div class="row">
                                    <div class="col-sm-6 col-md-7 text-right form-group pull-sm-right">
                                        Unit Entries
                                    </div>

                                    <div class="col-sm-6 col-md-5 form-group align-sm-left">
                                        <button type="button" class="btn btn-sm"
                                                :class="{ 'btn-excellent': !showUnitEntry, 'btn-default': showUnitEntry }"
                                                @click="setUnitEntry(false); showUnitEntry = !showUnitEntry">

                                                <span v-if="!showUnitEntry">
                                                    Create Unit Entry
                                                </span>
                                            <span v-else>
                                                Cancel
                                            </span>
                                        </button>
                                    </div>
                                </div>
                            </legend>

                            <form @submit.prevent="saveUnitEntry" accept-charset="UTF-8" novalidate="novalidate"
                                  data-vv-scope="unitEntry" v-if="showUnitEntry">

                                <div class="form-group has-feedback"
                                     :class="{'has-error': errors.has('unitEntry.UnitEntry[title]')}">
                                    <label for="unit-entry-title">Title</label>
                                    <input id="unit-entry-title"
                                           v-validate="'required'"
                                           v-model="unitEntry.title"
                                           name="UnitEntry[title]"
                                           type="text"
                                           class="form-control"
                                           aria-required="true">

                                    <span v-show="errors.has('unitEntry.UnitEntry[title]')" class="help-block">
                                        {{ errors.first('unitEntry.UnitEntry[title]') }}
                                    </span>
                                </div>

                                <div class="form-group has-feedback"
                                     :class="{'has-error': errors.has('unitEntry.UnitEntry[start_at]')}">
                                    <label for="unit-entry-start-at">Start At</label>

                                    <div class="row">
                                        <div class="col-xs-7">
                                            <input id="unit-entry-start-at-date"
                                                   type="date"
                                                   class="form-control"
                                                   v-model="unitEntry.start_at_date">
                                        </div>
                                        <div class="col-xs-5">
                                            <input id="unit-entry-start-at-time"
                                                   type="time"
                                                   class="form-control"
                                                   v-model="unitEntry.start_at_time">
                                        </div>
                                    </div>

                                    <input type="hidden"
                                           id="unit-entry-start-at"
                                           name="UnitEntry[start_at]"
                                           v-validate="'required'"
                                           :value="unitEntryStartAt">

                                    <span v-show="errors.has('unitEntry.UnitEntry[start_at]')"
                                          class="help-block">
                                        {{ errors.first('unitEntry.UnitEntry[start_at]') }}
                                    </span>
                                </div>

                                <div class="form-group has-feedback"
                                     :class="{'has-error': errors.has('unitEntry.UnitEntry[end_at]')}">
                                    <label for="unit-entry-end-at">End At</label>

                                    <div class="row">
                                        <div class="col-xs-7">
                                            <input id="unit-entry-end-at-date"
                                                   type="date"
                                                   class="form-control"
                                                   v-model="unitEntry.end_at_date">
                                        </div>
                                        <div class="col-xs-5">
                                            <input id="unit-entry-end-at-time"
                                                   type="time"
                                                   class="form-control"
                                                   v-model="unitEntry.end_at_time">
                                        </div>
                                    </div>

                                    <input type="hidden"
                                           id="unit-entry-end-at"
                                           name="UnitEntry[end_at]"
                                           v-validate="'required'"
                                           :value="unitEntryEndAt">

                                    <span v-show="errors.has('unitEntry.UnitEntry[end_at]')"
                                          class="help-block">
                                        {{ errors.first('unitEntry.UnitEntry[end_at]') }}
                                    </span>
                                </div>

                                <hr>

                                <div class="row">
                                    <div class="col-xs-6 form-group">
                                        <button type="button" class="btn btn-sm btn-warning"
                                                @click="deleteUnitEntry( unitEntry )"
                                                :disabled="loading">
                                            <i class="fa fa-trash" aria-hidden="true"></i>
                                        </button>
                                    </div>

                                    <div class="col-xs-6 form-group">
                                        <button type="submit" class="btn btn-success btn-block" :disabled="loading">
                                            Save Unit Entry
                                        </button>
                                    </div>
                                </div>

                                <br>
                            </form>

                            <ul class="list-group no-margin">
                                <li class="list-group-item link" v-for="listUnitEntry in model.unitEntries"
                                    :class="{'list-group-item-success active': unitEntry.id === listUnitEntry.id}"
                                    @click="setUnitEntry(listUnitEntry); showUnitEntry = true">
                                    <h5 class="text-bold margin-sm-bottom">{{listUnitEntry.title}}</h5>
                                    <h6>
                                        {{listUnitEntry.display_start_at}} - {{listUnitEntry.display_end_at}}
                                    </h6>
                                </li>
                            </ul>
                        </fieldset>
                    </tab>

                    <tab title="Notes" v-if="model.created_at">
                        <admin-notes noteable_type="App\InstallGroup" :noteable_id="model.id"
                                     :user_id="$root.user.id"></admin-notes>
                    </tab>
                </tabs>
            </div>
        </modal>
    </div>
</template>

<script>
    import model from "./mixins/model";

    export default {
        mixins: [ model ],

        props: {
            projectId: {
                type: String,
                default: null
            },
        },

        computed: {
            resourceKey(){
                return 'InstallGroup';
            },

            saveValidationKey(){
                return 'installGroup'
            },

            url(){
                if( this.model.id ){
                    return '/api/installGroups/' + this.model.id;
                }
                else {
                    return '/api/installGroups';
                }
            },

            notificationScheduledAt(){
                if( this.notification.scheduled_at_date && this.notification.scheduled_at_time ){
                    var result = moment( this.notification.scheduled_at_date + ' ' + this.notification.scheduled_at_time + ':00' );

                    return result.utc().format( 'YYYY-MM-DD HH:mm:ss' );
                }

                return null;
            },

            unitEntryMeta(){
                if( this.model ){
                    return _.reduce( this.model.unitEntries, ( carry, unitEntry ) => {

                        let hasUnsentEmailNotifications = !_.isEmpty( unitEntry.emailNotifications ) &&
                            _.every( unitEntry.emailNotifications, ( emailNotification ) => {
                                return emailNotification.sent_at === null && emailNotification.error_at === null;
                            } );

                        let hasUnsentSMSNotifications = !_.isEmpty( unitEntry.smsNotifications ) &&
                            _.every( unitEntry.smsNotifications, ( smsNotification ) => {
                                return smsNotification.sent_at === null;
                            } );

                        carry[ unitEntry.id ] = {
                            hasNotifications: !_.isEmpty( unitEntry.emailNotifications ) && !_.isEmpty( unitEntry.smsNotifications ),
                            hasUnsentNotifications: hasUnsentEmailNotifications || hasUnsentSMSNotifications
                        };

                        return carry;
                    }, {} );
                }

                return {};
            },

            unitEntryEndAt(){
                if( this.unitEntry.end_at_date && this.unitEntry.end_at_time ){
                    var result = this.unitEntry.end_at_date + ' ' + this.unitEntry.end_at_time;

                    if( this.unitEntry.end_at_time.length === 5 ){
                        result += ':00';
                    }

                    return result;
                }

                return null;
            },

            unitEntryStartAt(){
                if( this.unitEntry.start_at_date && this.unitEntry.start_at_time ){
                    var result = this.unitEntry.start_at_date + ' ' + this.unitEntry.start_at_time;

                    if( this.unitEntry.start_at_time.length === 5 ){
                        result += ':00';
                    }

                    return result;
                }

                return null;
            },
        },

        methods: {
            beforeSave(){
                this.model.project_id = this.projectId;
            },

            getModelData(){
                return {
                    closeOnSave: false,

                    unitBlock: {},

                    unitEntry: {},

                    showUnitEntryNotifications: {},

                    notification: {},

                    showUnitBlock: false,
                    showUnitEntry: false,
                    showCreateNotification: false,
                };
            },

            setModel( response ){
                var installGroup = response.data.InstallGroup;

                _.each( installGroup.unitEntries, ( unitEntry ) => {
                    _.each( unitEntry.emailNotifications, ( emailNotification ) => {
                        if( emailNotification.sent_at ){
                            emailNotification.sent_at = moment.utc( emailNotification.sent_at )
                                .local()
                                .format( 'MMM Do, YYYY hh:mm a' );
                        }

                        if( emailNotification.scheduled_at ){
                            emailNotification.scheduled_at = moment.utc( emailNotification.scheduled_at )
                                .local()
                                .format( 'MMM Do, YYYY hh:mm a' );
                        }
                    } );

                    _.each( unitEntry.smsNotifications, ( smsNotification ) => {
                        if( smsNotification.sent_at ){
                            smsNotification.sent_at = moment.utc( smsNotification.sent_at )
                                .local()
                                .format( 'MMM Do, YYYY hh:mm a' );
                        }

                        if( smsNotification.scheduled_at ){
                            smsNotification.scheduled_at = moment.utc( smsNotification.scheduled_at )
                                .local()
                                .format( 'MMM Do, YYYY hh:mm a' );
                        }
                    } );
                } );

                return this.$set( this, 'model', installGroup );
            },

            /** Unit Block CRUD **/
            saveUnitBlock(){
                var url = '/api/unitBlocks';

                return this.$validator.validateAll( 'unitBlock' )
                    .then( ( valid ) => {
                        if( valid ){
                            var promise;

                            if( this.unitBlock.id ){
                                promise = axios.put( url + '/' + this.unitBlock.id, {
                                    UnitBlock: this.unitBlock
                                } );
                            }
                            else {
                                this.unitBlock.install_group_id = this.model.id;

                                promise = axios.post( url, {
                                    UnitBlock: this.unitBlock
                                } );
                            }

                            promise.then( ( result ) => {
                                if( !this.unitBlock.id ){
                                    this.unitBlock = result.data.UnitBlock;
                                }

                                return this.init();
                            } )
                                .then( () => {
                                    this.$emit( 'afterSave' );

                                    this.$notify( {
                                        type: 'success',
                                        placement: 'top-left',
                                        title: 'Saved Unit Block',
                                    } );

                                    this.unitBlock = {};
                                    this.showUnitBlock = false;
                                } )
                                .finally( () => {
                                    this.loading = false;
                                } )
                                .catch( ( err ) => {
                                    return this.$root.handleErrors( err, 'unitBlock' );
                                } );
                        }
                    } );
            },

            deleteUnitBlock( unitBlock ){
                return axios.delete( '/api/unitBlocks/' + unitBlock.id )
                    .then( () => {
                        this.$emit( 'afterSave' );

                        this.$notify( {
                            type: 'success',
                            placement: 'top-left',
                            title: 'Archived Unit Block',
                        } );

                        this.showUnitBlock = false;

                        return this.init();
                    } )
                    .finally( () => {
                        this.loading = false;
                    } )
                    .catch( ( err ) => {
                        return this.$root.handleErrors( err, 'unitBlock' );
                    } );
            },

            setUnitBlock( unitBlock ){
                if( unitBlock ){
                    this.unitBlock = unitBlock;
                }
                else {
                    this.unitBlock = {};
                }
            },

            /** Unit Block CRUD **/
            saveUnitEntry(){
                var url = '/api/unitEntries';

                return this.$validator.validateAll( 'unitEntry' )
                    .then( ( valid ) => {
                        if( valid ){
                            var promise;

                            this.loading = true;
                            this.unitEntry.start_at = this.unitEntryStartAt;
                            this.unitEntry.end_at = this.unitEntryEndAt;

                            if( this.unitEntry.id ){
                                promise = axios.put( url + '/' + this.unitEntry.id, {
                                    UnitEntry: this.unitEntry
                                } );
                            }
                            else {
                                this.unitEntry.install_group_id = this.model.id;

                                promise = axios.post( url, {
                                    UnitEntry: this.unitEntry
                                } );
                            }

                            promise
                                .then( ( result ) => {
                                    if( !this.unitEntry.id ){
                                        this.unitEntry = result.data.UnitEntry;
                                    }

                                    return this.init();
                                } )
                                .then( () => {
                                    this.$emit( 'afterSave' );

                                    this.$notify( {
                                        type: 'success',
                                        placement: 'top-left',
                                        title: 'Saved Unit Entry',
                                    } );

                                    this.unitEntry = {};

                                    this.showUnitEntry = false;
                                } )
                                .finally( () => {
                                    this.loading = false;
                                } )
                                .catch( ( err ) => {
                                    return this.$root.handleErrors( err, 'unitEntry' );
                                } );
                        }
                    } );
            },

            deleteUnitEntry( unitEntry ){
                this.loading = true;

                return axios.delete( '/api/unitEntries/' + unitEntry.id )
                    .then( () => {
                        this.$emit( 'afterSave' );

                        this.$notify( {
                            type: 'success',
                            placement: 'top-left',
                            title: 'Archived Unit Entry',
                        } );

                        this.showUnitEntry = false;

                        return this.init();
                    } )
                    .finally( () => {
                        this.loading = false;
                    } )
                    .catch( ( err ) => {
                        return this.$root.handleErrors( err, 'unitEntry' );
                    } );
            },

            setUnitEntry( unitEntry ){
                if( unitEntry ){
                    this.unitEntry = unitEntry;
                }
                else {
                    this.unitEntry = {};
                }
            },

            // /** Notifications **/
            scheduleNotifications(){
                if( this.model.residents.length === 0 ){
                    this.$notify( {
                        type: 'warning',
                        placement: 'top-left',
                        title: 'No Residents to Schedule',
                    } );

                    return;
                }

                return this.$validator.validateAll( 'notifications' )
                    .then( ( valid ) => {
                        if( valid ){
                            var url = '/api/unitEntries/' + this.notification.unit_entry_id + '/scheduleNotifications';

                            this.loading = true;

                            return axios.post( url, {
                                'Notification': {
                                    scheduled_at: this.notificationScheduledAt,
                                }
                            } )
                                .then( () => {
                                    this.this.$emit( 'afterSave' );

                                    this.$notify( {
                                        type: 'success',
                                        placement: 'top-left',
                                        title: 'Scheduled Notifications',
                                    } );

                                    this.showCreateNotification = false;

                                    return this.init();
                                } )
                                .finally( () => {
                                    this.loading = false;
                                } )
                                .catch( ( err ) => {
                                    return this.$root.handleErrors( err, 'notifications' );
                                } );
                        }
                    } );
            },

            deleteEmailNotification( emailNotification ){
                this.loading = true;

                axios.delete( '/api/emailNotifications/' + emailNotification.id )
                    .then( () => {
                        this.$emit( 'afterSave' );

                        this.$notify( {
                            type: 'success',
                            placement: 'top-left',
                            title: 'Archived Email Notification',
                        } );

                        return this.init();
                    } )
                    .finally( ( err ) => {
                        this.loading = false;
                    } )
                    .catch( ( err ) => {
                        this.$root.handleErrors( err, 'notifications' );
                    } );
            },

            deleteSmsNotification( smsNotification ){
                this.loading = true;

                axios.delete( '/api/smsNotifications/' + smsNotification.id )
                    .then( () => {
                        this.$emit( 'afterSave' );

                        this.$notify( {
                            type: 'success',
                            placement: 'top-left',
                            title: 'Archived SMS Notification',
                        } );

                        return this.init();
                    } )
                    .finally( ( err ) => {
                        this.loading = false;
                    } )
                    .catch( ( err ) => {
                        this.$root.handleErrors( err, 'notifications' );
                    } );
            },

            deleteUnsentNotification( unitEntry ){
                var promises = [];
                this.loading = true;

                _.each( unitEntry.emailNotifications, ( emailNotification ) => {
                    if( emailNotification.sent_at === null && emailNotification.error_at === null ){
                        promises.push( axios.delete( '/api/emailNotifications/' + emailNotification.id ) );
                    }
                } );

                _.each( unitEntry.smsNotifications, ( smsNotification ) => {
                    if( smsNotification.sent_at === null ){
                        promises.push( axios.delete( '/api/smsNotifications/' + smsNotification.id ) );
                    }
                } );

                return Promise.all( promises )
                    .then( () => {
                        this.$emit( 'afterSave' );

                        this.$notify( {
                            type: 'success',
                            placement: 'top-left',
                            title: 'Archived Unsent Notifications',
                        } );

                        return this.init();
                    } )
                    .finally( () => {
                        this.loading = false;
                    } )
                    .catch( ( err ) => {
                        this.$root.handleErrors( err, 'notifications' );
                    } );
            },

            toggleUnitEntryNotifications( unitEntryId ){
                this.$set( this.showUnitEntryNotifications, unitEntryId, !this.showUnitEntryNotifications[ unitEntryId ] );
            },
        }
    }
</script>
